module.exports = __webpack_public_path__ + "static/media/plus_icon.d6b58131.svg";